export const getAnalyticsData = (data = {}) => {
  const { itemStatus, productStock = 0, backOrder, specialOrder } = data

  let analyticsAddToCart =
    '{"eventAction":"pdp:sticky nav:add to cart","eventName":"pdp:sticky nav:add to cart","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"add to cart","internalLinkPosition":"header","internalLinkType":"pdp:add to cart","internalLinkZoneName":"pdp:sticky nav","internalLinkURL":"n/a","clickInternalLinks":"true"}'
  if (itemStatus === "outOfStock" || !(productStock > 0)) {
    analyticsAddToCart = JSON.stringify({
      clickInternalLinks: "true",
      eventAction: "pdp:sticky nav:notify me",
      eventMsg: "n/a",
      eventName: "pdp:sticky nav:notify me",
      eventStatus: "n/a",
      eventType: "navigation",
      internalLinkName: "notify me",
      internalLinkPosition: "header",
      internalLinkType: "pdp:notify me",
      internalLinkURL: "n/a",
      internalLinkZoneName: "pdp:sticky nav",
    })
    if (specialOrder === "Yes" || backOrder === "Yes") {
      analyticsAddToCart =
        '{"eventAction":"pdp:sticky nav:add to cart","eventName":"pdp:sticky nav:add to cart","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"add to cart","internalLinkPosition":"header","internalLinkType":"pdp:add to cart","internalLinkZoneName":"pdp:sticky nav","internalLinkURL":"n/a","clickInternalLinks":"true"}'
    }
  } else if (itemStatus === "discontinued") {
    analyticsAddToCart =
      '{"eventAction":"pdp:find similar items","eventName":"pdp:find similar items","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"find similar items","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}'
  } else if (itemStatus === "preOrder") {
    analyticsAddToCart =
      '{"eventAction":"pdp:pre order","eventName":"pdp:pre order","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"pre order","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}'
  } else if (itemStatus === "specialOrder") {
    analyticsAddToCart =
      '{"eventAction":"pdp:special order","eventName":"pdp:special order","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"special order","internalLinkPosition":"pdp","internalLinkType":"pdp:navigation","internalLinkZoneName":"pdp:product details","internalLinkURL":"n/a","clickInternalLinks":"true"}'
  }

  return analyticsAddToCart
}
